import * as React from 'react';

const Comment16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.5 10.5v2.879L8.621 10.5H3A1.5 1.5 0 0 1 1.5 9V3A1.5 1.5 0 0 1 3 1.5h10A1.5 1.5 0 0 1 14.5 3v6a1.5 1.5 0 0 1-1.5 1.5zM13 12a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h5l3.293 3.293c.63.63 1.707.184 1.707-.707z"
  }
));
Comment16.Size = 16;
Comment16.Title = "Comment";

export { Comment16 as default };
